import React, {useState,useCallback} from "react";
import {PaymentElement,useStripe,useElements} from "@stripe/react-stripe-js";
import {Form,Button,Alert} from "react-bootstrap";

const BankPaymentForm = ({onSuccess,darkMode}) => {
  const stripe = useStripe();
  const elements = useElements();

  const [loading, setLoading] = useState(false);

  const [errorMessage, setErrorMessage] = useState("");

  /**
   * Optimized submit handler
   */
  const handleSubmit = useCallback(
    async (e) => {
      e.preventDefault();

      setErrorMessage("");

      if (!stripe || !elements || loading) {
        return;
      }

      setLoading(true);

      try {
        const { error, setupIntent } =
          await stripe.confirmSetup({
            elements,
            redirect: "if_required",
          });

        if (error) {
          setErrorMessage(
            error.message ||
              "Bank account setup failed."
          );

          return;
        }

        if (
          setupIntent?.payment_method
        ) {
          await onSuccess(
            setupIntent.payment_method
          );
        }
      } catch (error) {
        console.error(
          "Bank Payment Error:",
          error
        );

        setErrorMessage(
          "Something went wrong. Please try again."
        );
      } finally {
        setLoading(false);
      }
    },
    [stripe, elements, loading, onSuccess]
  );

  return (
    <Form onSubmit={handleSubmit}>
      <Form.Group className="mb-3">
        <div
          style={{
            padding: "14px",
            border: `1px solid ${
              darkMode
                ? "#444"
                : "#ced4da"
            }`,
            borderRadius: "8px",
            backgroundColor: darkMode
              ? "#1e1e1e"
              : "#ffffff",
            transition:
              "all 0.2s ease-in-out",
          }}
        >
          <PaymentElement />
        </div>
      </Form.Group>

      {!!errorMessage && (
        <Alert variant="danger">
          {errorMessage}
        </Alert>
      )}

      <div className="d-flex justify-content-end mt-3">
        <Button
          type="submit"
          disabled={
            loading ||
            !stripe ||
            !elements
          }
          className="start_subscription_trigger"
        >
          {loading
            ? "Processing..."
            : "Start Subscription"}
        </Button>
      </div>
    </Form>
  );
};

export default React.memo(BankPaymentForm);